import './PrivacyPolicy.css';
import ResizingIFrame from '../ResizingIFrame.js';

function ImpureChessTermsAndConditions()
{
    return (
        <div className="PrivacyPolicy-Container">
            <ResizingIFrame id='ImpureChessTermsAndConditions-Static-Container' iFrameTitle='Impure Chess Terms and Conditions' htmlName='ImpureChessTermsAndConditions/ImpureChessTermsAndConditions.html' />
        </div>
    );
}

export default ImpureChessTermsAndConditions;